import { render, staticRenderFns } from "./RecommendationsComponent.vue?vue&type=template&id=6fff31c4"
import script from "./RecommendationsComponent.vue?vue&type=script&lang=js"
export * from "./RecommendationsComponent.vue?vue&type=script&lang=js"
import style0 from "./RecommendationsComponent.vue?vue&type=style&index=0&id=6fff31c4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports